import axios from 'axios';
import alerts from '../alerts.js';

class Auth {
    /**
     * Auth constructor function
     */
    constructor() {
        this.token = window.localStorage.getItem('token');
        this.user = JSON.parse(window.localStorage.getItem('user'));

        /*
        this.token = (null || $('#globals').find('#token').val());

        if ($('#globals').find('#user').length) {
            this.user = JSON.parse($('#globals').find('#user').val());
        } else {
            this.user = null;
        }
        */

        this.bindAxios();
    }


    /**
     * Check if the user is currently authenticated
     */
    check() {
        return !! this.token;
    }


    /**
     *
     * @param {{}} user
     * @param {string} token
     *
     * Log user in and store in local storage
     */
    login(user, token) {
        this.token = token;
        this.user = user;

        window.localStorage.setItem('token', this.token);
        window.localStorage.setItem('user', JSON.stringify(this.user));

        // Add the bearer token and global error handler
        this.bindAxios();

        Event.emit('userLoggedIn');
    }


    /**
     * Logout the user
     */
    logout() {
        this.token = null;
        this.user = null;

        window.localStorage.removeItem('token');
        window.localStorage.removeItem('user');

        Event.emit('userLoggedOut');
    }


    /**
     * Add the bearer token and global error handler
     */
    bindAxios() {
        var auth = this;

        if (this.check()) {
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + this.token;
        } else {
            axios.defaults.headers.common['Authorization'] = null;
        }

        // Let axios/browser set Content-Type automatically based on payload.
        // For JSON objects, axios will send application/json; for FormData, the browser will set multipart/form-data with boundary.

        // Bind all axios requests
        axios.interceptors.request.use((config) => {
            $('.is-invalid').removeClass('is-invalid');
            $(':input[type="submit"]').prop('disabled', true).addClass('disabled');
            //$(this).find('.btn').attr('disabled', 'disabled').addClass('disabled auto-disabled');

            //alert(JSON.stringify(config.headers));

            return config;
        });

        // Bind all axios responses
        axios.interceptors.response.use(function(response) {
            $(':input[type="submit"]').prop('disabled', false).removeClass('disabled');
            $('.btn.auto-disabled').removeClass('disabled auto-disabled').attr('disabled', false);
            return response;

        }, function(error) {
            $(':input[type="submit"]').prop('disabled', false).removeClass('disabled');
            $('.btn.auto-disabled').removeClass('disabled auto-disabled').attr('disabled', false);

            // Unauthorized
            if (error.response.status === 401 && auth.check()) {
                auth.logout();
                window.location.href = '/login';

            } else {
                if (error.response.status !== 511) {
                    alerts.showErrors(error.response.data);
                }
            }

            return Promise.reject(error);
        });
    }
}

// Singleton to prevent duplicate Axios bindings, consistent auth state
export default new Auth;
